import React from 'react';
import loadingDual from './Dual Ball-1s-200px.svg'
export default function Loading(props) {
    const parentStyle = {
        width: props.staticalView ? '40%' : '100%',
        // height: 'calc(100vh - 280px)',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: 0
    }
    const svgStyle = {
        width: 85,
        height: 85,
        position: 'absolute',
        zIndex: 999,
    }
    return (
        <div style={parentStyle}>
            <img style={svgStyle} src={loadingDual} alt=""/>
        </div>
    );
}